import { render, staticRenderFns } from "./StaffInput.vue?vue&type=template&id=18aeaf8a&"
import script from "./StaffInput.vue?vue&type=script&lang=js&"
export * from "./StaffInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports